<template>
    <div>
        <div class="row form-group">
            <div class="col-12">
                <hr />
            </div>
        </div>

        <div class="row form-group">
            <div class="col-6">
                <settings-property>
                    <template #label="{id}">
                        <label :for="id">{{resource('JourneyBuilder_TimerSettings_Date_Label')}}</label>
                    </template>
                    <template #input="{id}">
                        <date-picker v-model="dateModel"
                                     :options="{ 
                                        disabled: !canWrite, 
                                        typeable: false,
                                        id: id 
                                     }"
                        />
                    </template>
                    <template #errors>
                        <required-error-message v-if="$v.date.$dirty && $v.date.$invalid"  />
                    </template>
                </settings-property>
            </div>

            <div class="col-6">
                <settings-property>
                    <template #label>
                        <label>{{resource('JourneyBuilder_TimerSettings_Time_Label')}}</label>
                    </template>
                    <template #input>
                        <time-picker v-model="timeModel" :readonly="!canWrite" />
                    </template>
                    <template #errors>
                        <required-error-message v-if="$v.time.$dirty && $v.time.$invalid" />
                    </template>
                </settings-property>
            </div>
        </div>
    </div>
</template>

<script>
import dateHelpers from '@modules/JourneyBuilder/Util/date-helpers';
import { timerScheduleOnceValidations } from './validations';

import { validationMixin } from 'vuelidate';
import permissionsMixin from "@modules/JourneyBuilder/Mixins/journey-permissions";
import resourceMixin from "@core/Util/Mixins/resources";

import SettingsProperty from "../SettingsProperty";
import DatePicker from "@core/Components/Util/DatePicker";
import TimePicker from "@core/Components/Inputs/TimePicker";
import RequiredErrorMessage from "@core/Components/Errors/RequiredErrorMessage";

export default {
    name: "BrickTimerScheduleOnceSettings",
    
    mixins: [validationMixin, permissionsMixin, resourceMixin],
    
    components: {
        SettingsProperty,
        DatePicker,
        TimePicker,
        RequiredErrorMessage
    },
    
    props: {
        date: {
            type: String,
            required: false
        },
        time: {
            type: Object,
            required: false
        }
    },
    
    computed: {
        dateModel: {
            get() {
                return this.date && dateHelpers.getDateFromString(this.date);
            },
            set(value) {
                this.$emit('update:date', value && dateHelpers.getStringifiedDate(value))
            }
        },
        timeModel: {
            get() {
                return this.time;
            },
            set(value) {
                this.$emit('update:time', value);
            }
        }
    },
    
    validations: timerScheduleOnceValidations,
    
    methods: {
        displayErrors() {
            this.$v.$touch();
        }
    }
}
</script>
